module.exports = __webpack_public_path__ + "topText-green-bg.png?2bbfbb77291dc4d29508b80a016904d4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/topText-green-bg.png
// module id = 6
// module chunks = 0